import { formatDate } from 'helpers/date';

const today = formatDate(new Date(), 'dd/MM/yyyy');

export type ExportStatement = {
  date: [string, string];
  email?: string;
  financial_statement: boolean;
  export_in_future: boolean;
  export_blocked: boolean;
};

export type Props = {
  isOpen: boolean;
  showSuccess?: boolean;
  setClose: () => void;
};

export const initialFilter: ExportStatement = {
  date: [today, today],
  email: '',
  financial_statement: true,
  export_in_future: false,
  export_blocked: false
};
